import { H1 } from "../components/h1";
import { useLocale } from "../stores/locale";

export function Home() {
  const t = useLocale((state) => state.locale);

  return (
    <div className="grow flex items-center justify-center">
      <H1>{t.home.welcome}</H1>
    </div>
  );
}
